var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconListArrowNextLight = function SvgIconListArrowNextLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96 6.48a.75.75 0 0 1 1.06-.02l4.866 4.687a1.18 1.18 0 0 1 0 1.706L10.02 17.54a.75.75 0 1 1-1.04-1.08L13.609 12l-4.63-4.46a.75.75 0 0 1-.02-1.06Z",
    fill: "current"
  })));
};
export default SvgIconListArrowNextLight;